import { pointKey } from '../data/levels';
import type { GridPoint } from '../types';

export function sameCell(a: GridPoint, b: GridPoint): boolean {
  return a.x === b.x && a.y === b.y;
}

export function availableNeighbors(point: GridPoint, paths: Set<string>): GridPoint[] {
  return [
    { x: point.x + 1, y: point.y },
    { x: point.x - 1, y: point.y },
    { x: point.x, y: point.y + 1 },
    { x: point.x, y: point.y - 1 },
  ].filter((candidate) => paths.has(pointKey(candidate)));
}

